export const ERROR_CODE_ASSIGN_FORM_EDIT = 1;
export const ERROR_CODE_UPDATE_IN_TASK_CANCEL = 1002;